import {Injectable} from '@angular/core';
import {BaseEndpointService} from '../base-endpoint-service';
import {Backend} from '@generated-backend-types';
import SentEmail = Backend.App.Resources.Dashboard.SentEmail;
import {ListItem} from '../../../entities/list-item.entity';

@Injectable({providedIn: 'root'})
export class SentEmailService extends BaseEndpointService<SentEmail> {
  protected override endpoint = '/administration/sent-emails';

  public override modelToMultiSelectItem(m: SentEmail): ListItem & { model: SentEmail } {
    return {
      id: m.id,
      text: m.id,
      isDisabled: false,
      model: m,
    }
  }
}
